import * as React from 'react';
import { connect } from 'react-redux';

import MoreButton from 'components/buttons/more-button/MoreButton';
import { withContextMenu } from 'components/context-menu/ContextMenuHOC';

import {
  deleteEntireSnippet,
  downloadSnippetAttachments,
  updateCanEditAndNotify
} from '../../redux/actions';

import { getContextMenuItems } from '../../utils/context-menu';

import { State } from 'types';

const MoreButtonWithMenu = withContextMenu(MoreButton, {
  position: 'bottom',
  canEmpty: true
});

interface OwnProps {
  deliverableId: number, // eslint-disable-line react/no-unused-prop-types
  snippetId: number // eslint-disable-line react/no-unused-prop-types
}

interface StateProps {
  canEdit: boolean,
  snippetIsSaved: boolean
}

interface DispatchProps {
  dispatchDownloadAll: () => void,
  dispatchDeleteAll: () => void,
  dispatchEditContent: () => void
}

type Props = OwnProps & StateProps & DispatchProps;

const StoryContextMenu = ({
  snippetIsSaved,
  canEdit,
  dispatchDeleteAll,
  dispatchDownloadAll,
  dispatchEditContent
}: Props) => (
  <MoreButtonWithMenu
    contextMenuProps={{
      items: getContextMenuItems(
        snippetIsSaved,
        canEdit,
        dispatchDeleteAll,
        dispatchDownloadAll,
        dispatchEditContent
      )
    }}
  />
);

const mapStateToProps = (
  { storySnippets }: State,
  { deliverableId, snippetId }: OwnProps
): StateProps => ({
  canEdit: !!storySnippets.deliverables[deliverableId]?.canEdit,
  snippetIsSaved: !!(storySnippets.deliverables[deliverableId]?.snippets ?? [])
    .find(snip => snip.id === snippetId)?.saved
});

const mapDispatchToProps = (
  dispatch,
  { snippetId, deliverableId }: OwnProps
): DispatchProps => ({
  dispatchDeleteAll: () => dispatch(deleteEntireSnippet(deliverableId, snippetId!)),
  dispatchDownloadAll: () => dispatch((downloadSnippetAttachments(deliverableId, snippetId))),
  dispatchEditContent: () => dispatch(updateCanEditAndNotify(deliverableId, true))
});

export default connect(mapStateToProps, mapDispatchToProps)(StoryContextMenu);
